<div class="re-mt-60 md:re-mt-90 bdo-container">
  <bdo-section-headline>
    {{ 'general.headline.faqTitle' | translate }}
  </bdo-section-headline>
</div>

@if (arrayOfFaqs.length > 0) {
  <div class="bdo-container--single">
    <bdo-accordion>
      @for (faqKey of arrayOfFaqs; track faqKey) {
        <bdo-accordion-item title="{{ keyName + '.' + faqKey + '.question' | translate: params }}">
          <div [innerHTML]="keyName + '.' + faqKey + '.answer' | translate: params" bdoRouterLinkDirective></div>
        </bdo-accordion-item>
      }
    </bdo-accordion>
  </div>
}
